export default __webpack_public_path__ + "static/media/media-placeholder.15cc8fd8.jpg";